import { API_URL } from "../config/constants";

interface TransportAvailabilityRequest {
  isAvailable: boolean;
}

interface TransportAvailabilityResponse {
  email: string;
  firstName: string;
  lastName: string;
  isAvailable: boolean;
  licensePlate: string;
  phone: string;
  whatsapp?: string;
  startTime?: string;
  endTime?: string;
  isPublic: boolean;
  paymentMethods?: string[];
  categoryName?: string;
}


export async function updateAvailability(
  id: string,
  data: TransportAvailabilityRequest
): Promise<TransportAvailabilityResponse> {
    const response = await fetch(`${API_URL}/transport/${id}/availability`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return response.json();
  }

